export class TableConfiguration {
    constructor(config) {
        this.ConfigurationName = config.ConfigurationName;
        this.ProductName = config.ProductName;
        this.Value = config.value;
        this.Description = config.description;
        this.TimestampUTC = config.timestamp
    }
}